import { useMemo } from 'react';
import { TooltipWrapperWithComponentAndState } from '../adminComponents';
import { PosSuccessIcon, PosFailedIcon, PosIcon } from '../assets';
import { renderPosImage } from '../helpers';
import { Div, Img, lightTheme, P } from '../styles';
import { PosInjectionStatus, PosType } from '../types';

export const PosIconTooltip = ({
  id,
  posType,
  posInjectionStatus,
}: {
  id?: number;
  posType?: PosType;
  posInjectionStatus?: PosInjectionStatus | null;
}) => {
  // Inside PosIconTooltip
  const tooltipContent = useMemo(
    () => (
      <Div>
        <P $m="0" $center $maxWidth="100px">
          {posInjectionStatus === PosInjectionStatus.INJECTED
            ? 'Successfully pushed to POS'
            : posInjectionStatus === PosInjectionStatus.REJECTED
            ? 'Failed to push to POS'
            : ''}
        </P>
        {posType && (
          <Div
            $height="50px"
            $heightSM="50px"
            $width="100px"
            $flex
            $center
            $justifyCenter
            $relative
            $mt={posInjectionStatus === null ? '0' : '8'}
          >
            <Div
              $background={lightTheme.white}
              $borderRadius="12px"
              $box
              $boxNoShadow
              $p="0 12px"
              style={{ backgroundColor: 'white' }}
              $width="100px"
            >
              <Img
                src={renderPosImage(posType ?? '')}
                $height="50px"
                alt={posType ?? ''}
              />
            </Div>
          </Div>
        )}
      </Div>
    ),
    [posType]
  );

  const tooltipId = `tt-${id}-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <TooltipWrapperWithComponentAndState
      id={tooltipId}
      tooltip={tooltipContent}
      style={{
        width: posInjectionStatus === null ? '22px' : '32px',
        height: posInjectionStatus === null ? '22px' : '24px',
      }}
    >
      {posInjectionStatus === PosInjectionStatus.INJECTED ? (
        <PosSuccessIcon />
      ) : posInjectionStatus === PosInjectionStatus.REJECTED ? (
        <PosFailedIcon />
      ) : (
        <PosIcon />
      )}
    </TooltipWrapperWithComponentAndState>
  );
};
